import onReady from '@/scripts/modules/on-ready';

onReady( () => {
	const tabGroups = document.querySelectorAll( '.course-tabs' );

	if ( 0 < tabGroups.length ) {
		tabGroups.forEach( ( tabGroup ) => {
			const tabButtons =
				tabGroup.querySelectorAll( '.course-tab-toggle' );
			const tabContents = tabGroup.querySelectorAll(
				'.course-tab-content'
			);

			if ( 0 < tabButtons.length ) {
				tabButtons.forEach( ( tabButton ) => {
					tabButton.addEventListener( 'click', () => {
						const tabID = tabButton.getAttribute( 'aria-controls' );

						tabButtons.forEach( ( button ) => {
							button.setAttribute( 'aria-selected', 'false' );
						} );

						tabContents.forEach( ( tabContent ) => {
							tabContent.classList.remove( 'opened' );
						} );
						const activeTabContent = document.querySelector(
							'#' + tabID
						);
						activeTabContent.classList.add( 'opened' );
						tabButton.setAttribute( 'aria-selected', 'true' );
					} );
				} );
			}
		} );
	}
} );
